export default __webpack_public_path__ + "static/media/block3Item.fcff5ba8.svg";